<footer class="footer">
  <div>

    <section class="footer-marcas text-center py-5">
      <div class="container">
        <h2 class="fw-bold mb-4 text-primary">Empleo a tu medida con ManpowerGroup</h2>
        
        <div class="mb-5">
          <img src="/assets/img/logo-manpowergroup.png" alt="ManpowerGroup" class="logo-principal mb-4">
        </div>

        <!-- <div class="row justify-content-center align-items-center g-4">
          <div class="col-6 col-md-2">
            <img src="/assets/img/home/Manpower/mp logo.png" alt="Talent Solutions" class="logo-secundario">
          </div>
          <div class="col-6 col-md-2">
            <img src="/assets/img/home/Experis/banners job board-06.png" alt="Manpower" class="logo-secundario">
          </div>
          <div class="col-6 col-md-2">
            <img src="/assets/img/home/TS/Logo TS.png" alt="Experis" class="logo-secundario">
          </div>
        </div> -->
      </div>
    </section>

   <div class="logo-carousel bg-white">
      <!-- <div class="brand-section">
        <h5 class="mb-4 text-center">Empleo a tu medida con ManpowerGroup.</h5>
        <div class="logo-mpg"><img src="/assets/img/logo-manpowergroup.png" alt="Logo ManpowerGroup"></div>
      </div> -->
      
      <div class="logo-track d-flex align-items-center">
        <div class="logo-item"><img src="/assets/img/home/Manpower/mp logo.png" alt="Logo Manpower"></div>
        <div class="logo-item"><img src="/assets/img/home/Experis/banners job board-06.png" alt="Logo Experis"></div>
        <div class="logo-item"><img src="/assets/img/home/TS/Logo TS.png" alt="Logo Talent Solutions"></div>

        <div class="logo-item"><img src="/assets/img/home/Manpower/mp logo.png" alt="Logo Manpower"></div>
        <div class="logo-item"><img src="/assets/img/home/Experis/banners job board-06.png" alt="Logo Experis"></div>
        <div class="logo-item"><img src="/assets/img/home/TS/Logo TS.png" alt="Logo Talent Solutions"></div>

        <div class="logo-item"><img src="/assets/img/home/Manpower/mp logo.png" alt="Logo Manpower"></div>
        <div class="logo-item"><img src="/assets/img/home/Experis/banners job board-06.png" alt="Logo Experis"></div>
        <div class="logo-item"><img src="/assets/img/home/TS/Logo TS.png" alt="Logo Talent Solutions"></div>
      </div>
    </div>
  </div>

  <div class="black-section">
    <div class="container">
      <ul>
        <li><a href="https://www.manpowergroup.com.mx/condiciones_de_uso" target="_blank">Términos de uso</a></li>
        <li><a href="https://www.manpowergroup.com.mx/politica-de-cookies" target="_blank">Políticas de uso de cookies</a></li>
        <li><a href="https://www.manpowergroup.com.mx/politica-de-privacidad" target="_blank">Políticas de Privacidad</a></li>
      </ul>

      <div class="position-relative d-none d-sm-block">
        <div class="position-absolute top-0 start-0">© 2025 ManpowerGroup All Rights Reserved.</div>
        <div class="position-absolute top-50 start-50">
          <div class="redes">
            <div class="img">
              <a href="https://www.tiktok.com/@manpowergroup_mx?_t=ZS-8vmnXktX9lJ&_r=1" target="_blank">
                <img src="/assets/img/footer/tiktok-ico.png">
              </a>
            </div>
            <div class="img">
              <a href="https://www.linkedin.com/company/manpower-mexico/about" target="_blank">
                <img src="/assets/img/footer/2254256_RCcoverLI_wite.png">
              </a>
            </div>
            <div class="img">
              <a href="https://www.facebook.com/ManpowerGroupMeCA" target="_blank">
                <img src="/assets/img/footer/2254256_RCcoverFB_white.png">
              </a>
            </div>
            <div class="img">
              <a href="https://twitter.com/manpowermexico" target="_blank">
                <img src="/assets/img/footer/2254256_RCcoverX_white.png">
              </a>
            </div>
            <div class="img">
              <a href="https://www.instagram.com/manpowergroup_meca" target="_blank">
                <img src="/assets/img/footer/2254256_RCcoverIG_white.png">
              </a>
            </div>
            <div class="img">
              <a href="https://www.youtube.com/user/ManpowerLatino" target="_blank">
                <img src="/assets/img/footer/2254256_RCcoverYT_white.png">
              </a>
            </div>
          </div>
        </div>
        <!-- <div class="position-absolute top-0 end-0">Global (English)</div> -->
      </div>

      <div class="position-relative d-block d-sm-none">
        <div class="position-absolute top-50">
          <div class="redes">
            <div class="img">
              <a href="https://www.tiktok.com/@manpowergroup_mx?_t=ZS-8vmnXktX9lJ&_r=1" target="_blank">
                <img src="/assets/img/footer/tiktok-ico.png">
              </a>
            </div>
            <div class="img">
              <a href="https://www.linkedin.com/company/manpower-mexico/about" target="_blank">
                <img src="/assets/img/footer/2254256_RCcoverLI_wite.png">
              </a>
            </div>
            <div class="img">
              <a href="https://www.facebook.com/ManpowerGroupMeCA" target="_blank">
                <img src="/assets/img/footer/2254256_RCcoverFB_white.png">
              </a>
            </div>
            <div class="img">
              <a href="https://twitter.com/manpowermexico" target="_blank">
                <img src="/assets/img/footer/2254256_RCcoverX_white.png">
              </a>
            </div>
            <div class="img">
              <a href="https://www.instagram.com/manpowergroup_meca" target="_blank">
                <img src="/assets/img/footer/2254256_RCcoverIG_white.png">
              </a>
            </div>
            <div class="img">
              <a href="https://www.youtube.com/user/ManpowerLatino" target="_blank">
                <img src="/assets/img/footer/2254256_RCcoverYT_white.png">
              </a>
            </div>
          </div>
        </div>
        
        <div class="position-absolute top-0 derechos-reservados">© 2025 ManpowerGroup All Rights Reserved.</div>
      </div>
    </div>
  </div>
</footer>